import { ITranslationStringsBlueprint } from '@sparelabs/translate'
import { PermissionSetGroupingKey } from '../PermissionSetTypes'
import {
  AdminUserPermissionSet,
  AiAgentPermissionSet,
  AiPermissionSet,
  AnalyticsPermissionSet,
  AnalyticsTemplateLibraryPermissionSet,
  AnnouncementPermissionSet,
  ApiKeyPermissionSet,
  AppPermissionSet,
  AuditLogPermissionSet,
  AuthorizationGroupPermissionSet,
  BulkMessagePermissionSet,
  CancellationReasonPermissionSet,
  CasePermissionSet,
  CaseTypePermissionSet,
  ChargePermissionSet,
  CommentPermissionSet,
  CustomLinkPermissionSet,
  DataRetentionSchedulePermissionSet,
  DefaultSuperAdminPermissionSet,
  DevicePermissionSet,
  DriverBreakPermissionSet,
  DriverPermissionSet,
  DriverUserPermissionSet,
  DutyDelayPermissionSet,
  DutyPermissionSet,
  DutyRequestOfferPermissionSet,
  EamAssetPermissionSet,
  EamContactPermissionSet,
  EamEnergyEntryPermissionSet,
  EamInspectionFormPermissionSet,
  EamInspectionPermissionSet,
  EamInventoryPermissionSet,
  EamLocationPermissionSet,
  EamMeterEntryPermissionSet,
  EamPurchaseOrderPermissionSet,
  EamServiceEntryPermissionSet,
  EamServiceProgramPermissionSet,
  EamServiceReminderPermissionSet,
  EamServiceSchedulePermissionSet,
  EamServiceScheduleTaskPermissionSet,
  EamServiceTaskPermissionSet,
  EamSettingPermissionSet,
  EamVendorPermissionSet,
  EamWorkOrderPermissionSet,
  EdiBrokerConfigurationPermissionSet,
  EdiEligibilityCheckPermissionSet,
  EngageReportingPermissionSet,
  EngineeringLeadPermissionSet,
  EventPermissionSet,
  FarePassPermissionSet,
  FareRulePermissionSet,
  FavoriteLocationPermissionSet,
  FleetPermissionSet,
  FormPermissionSet,
  GroupPermissionSet,
  GtfsRealtimePermissionSet,
  IvrPermissionSet,
  JourneyPermissionSet,
  KnowledgeEntryPermissionSet,
  LaunchReportingPermissionSet,
  LetterPermissionSet,
  MatchingOutcomePermissionSet,
  NotificationSettingPermissionSet,
  NylasAdminGrantPermissionSet,
  OperationalAlertsPermissionSet,
  OrganizationPermissionSet,
  PartnerSuccessPermissionSet,
  PaymentMethodPermissionSet,
  PaymentMethodTypePermissionSet,
  PermissionSetType,
  PhoneNumberPermissionSet,
  PlatformPermissionSet,
  PromoPermissionSet,
  QuickReplyPermissionSet,
  RealizePermissionSet,
  RequestPermissionSet,
  ResolveReportingPermissionSet,
  ReviewPermissionSet,
  RiderDriverRestrictionPermissionSet,
  RiderOnboardingFlowPermissionSet,
  RiderPermissionSet,
  RiderRepresentativePermissionSet,
  RiderRiderRestrictionPermissionSet,
  RiderUserPermissionSet,
  RiderVehicleTypeRestrictionPermissionSet,
  RootSuperAdminPermissionSet,
  ServicePermissionSet,
  SiteReliabilityEngineerPermissionSet,
  SuperAdminTestRolePermissionSet,
  TicketPermissionSet,
  TimeRulePermissionSet,
  TipPermissionSet,
  UserBanPermissionSet,
  UserFleetAgreementPermissionSet,
  UserOnlyTokenPermissionSet,
  UserOwnPermissionSet,
  VehiclePermissionSet,
  VehicleTypePermissionSet,
  WebhookPermissionSet,
  WorkflowPermissionSet,
} from '../sets'
import { AccessGrantPermissionSet } from '../sets/AccessGrantPermissions'
import { AuthorizationGroupMembershipPermissionSet } from '../sets/AuthorizationGroupMembershipPermissions'
import { AuthorizationRolePermissionSet } from '../sets/AuthorizationRolePermissions'
import { DirectorySyncPermissionSet } from '../sets/DirectorySyncPermissions'
import { EamIssuePermissionSet } from '../sets/EamIssuePermissions'
import { EamPartPermissionSet } from '../sets/EamPartPermissions'
import { FixedRouteForDisplayPermissionSet } from '../sets/FixedRouteForDisplayPermissions'
import { GtfsPermissionsSet } from '../sets/GtfsPermissions'
import { NotificationDeliveryPolicyPermissionSet } from '../sets/NotificationDeliveryPolicyPermissions'
import { ProviderPermissionSet } from '../sets/ProviderPermissions'
import { SidebarProductVisibilityPermissionSet } from '../sets/SidebarProductVisibilityPermissions'
import { TripGroupPermissionSet } from '../sets/TripGroupPermissions'

export const permissionSetGroupingsEn = {
  name: {
    [PermissionSetGroupingKey.SuperAdminDefault]: 'Super Admin Default',
    [PermissionSetGroupingKey.SuperAdminEngineeringLead]: 'Super Admin Engineering Lead',
    [PermissionSetGroupingKey.SuperAdminPartnerSuccess]: 'Super Admin Partner Success',
    [PermissionSetGroupingKey.SuperAdminRoot]: 'Super Admin Root',
    [PermissionSetGroupingKey.SuperAdminSiteReliabilityEngineer]: 'Super Admin Site Reliability Engineer',
    [PermissionSetGroupingKey.SuperAdminTestRole]: 'Super Admin Test',
    [PermissionSetGroupingKey.AdminUser]: 'Platform User',
    [PermissionSetGroupingKey.AccessGrant]: 'Access Grant',
    [PermissionSetGroupingKey.AiAgent]: 'AI Voice',
    [PermissionSetGroupingKey.Ai]: 'Spare AI',
    [PermissionSetGroupingKey.Analytics]: 'Spare Analytics',
    [PermissionSetGroupingKey.AnalyticsTemplateLibrary]: 'Analytics Template Library',
    [PermissionSetGroupingKey.Announcement]: 'App Announcements',
    [PermissionSetGroupingKey.ApiKey]: 'API Key',
    [PermissionSetGroupingKey.App]: 'App',
    [PermissionSetGroupingKey.AuditLog]: 'Audit Log',
    [PermissionSetGroupingKey.AuthorizationGroup]: 'User Groups',
    [PermissionSetGroupingKey.AuthorizationGroupMembership]: 'User Group Memberships',
    [PermissionSetGroupingKey.AuthorizationRole]: 'Roles',
    [PermissionSetGroupingKey.BulkMessage]: 'Bulk Message',
    [PermissionSetGroupingKey.CancellationReason]: 'Cancellation Reason',
    [PermissionSetGroupingKey.DriverBreakReason]: 'Driver Break Reason',
    [PermissionSetGroupingKey.QuickReply]: 'Quick Reply',
    [PermissionSetGroupingKey.Case]: 'Case',
    [PermissionSetGroupingKey.CaseType]: 'Case Type',
    [PermissionSetGroupingKey.Charge]: 'Charge',
    [PermissionSetGroupingKey.Comment]: 'Comment',
    [PermissionSetGroupingKey.ConnectedAccount]: 'Connected Account',
    [PermissionSetGroupingKey.CustomLink]: 'Custom Links',
    [PermissionSetGroupingKey.DataRetentionSchedule]: 'Data Retention Schedule',
    [PermissionSetGroupingKey.Device]: 'Device',
    [PermissionSetGroupingKey.DirectorySync]: 'Directory Sync',
    [PermissionSetGroupingKey.Driver]: 'Driver',
    [PermissionSetGroupingKey.DriverUser]: 'Driver',
    [PermissionSetGroupingKey.DriverBreak]: 'Driver Breaks',
    [PermissionSetGroupingKey.Duty]: 'Duty',
    [PermissionSetGroupingKey.DutyDelay]: 'Duty Delay',
    [PermissionSetGroupingKey.DutyRequestOffer]: 'Duty Request Offer',
    [PermissionSetGroupingKey.EngageReporting]: 'Eligibility Reporting',
    [PermissionSetGroupingKey.Event]: 'Event',
    [PermissionSetGroupingKey.FarePass]: 'Fare Pass',
    [PermissionSetGroupingKey.FareRule]: 'Fare Rule',
    [PermissionSetGroupingKey.FavoriteLocation]: 'Favorite Location',
    [PermissionSetGroupingKey.FixedRouteForDisplay]: 'Fixed Route for Display',
    [PermissionSetGroupingKey.Form]: 'Form Setup',
    [PermissionSetGroupingKey.Group]: 'Rider Group',
    [PermissionSetGroupingKey.Ivr]: 'IVR',
    [PermissionSetGroupingKey.Journey]: 'Journey',
    [PermissionSetGroupingKey.KnowledgeEntry]: 'Knowledge Entry',
    [PermissionSetGroupingKey.LaunchReporting]: 'Operations Reporting',
    [PermissionSetGroupingKey.Letter]: 'Letter',
    [PermissionSetGroupingKey.MatchingOutcome]: 'Matching Outcome',
    [PermissionSetGroupingKey.NotificationDeliveryPolicy]: 'Notification Delivery Policy',
    [PermissionSetGroupingKey.NotificationSetting]: 'Notification Preferences',
    [PermissionSetGroupingKey.OperationalAlerts]: 'Operational Alerts',
    [PermissionSetGroupingKey.Organization]: 'Organization',
    [PermissionSetGroupingKey.PaymentMethod]: 'Payment Method',
    [PermissionSetGroupingKey.PaymentMethodType]: 'Payment Method Type',
    [PermissionSetGroupingKey.PhoneNumber]: 'Phone Number',
    [PermissionSetGroupingKey.Platform]: 'Platform',
    [PermissionSetGroupingKey.Promo]: 'Promo',
    [PermissionSetGroupingKey.Provider]: 'Provider',
    [PermissionSetGroupingKey.Realize]: 'Realize',
    [PermissionSetGroupingKey.ResolveReporting]: 'Resolve Reporting',
    [PermissionSetGroupingKey.Request]: 'Request',
    [PermissionSetGroupingKey.Review]: 'Review',
    [PermissionSetGroupingKey.Rider]: 'Rider',
    [PermissionSetGroupingKey.RiderDriverRestriction]: 'Rider-Driver Restriction',
    [PermissionSetGroupingKey.RiderRiderRestriction]: 'Rider-Rider Restriction',
    [PermissionSetGroupingKey.RiderOnboardingFlow]: 'Rider Guide',
    [PermissionSetGroupingKey.RiderVehicleTypeRestriction]: 'Allowed Vehicle Types',
    [PermissionSetGroupingKey.RiderUser]: 'Rider',
    [PermissionSetGroupingKey.SidebarProductVisibility]: 'Product Visibility',
    [PermissionSetGroupingKey.Service]: 'Service',
    [PermissionSetGroupingKey.Simulation]: 'Simulation',
    [PermissionSetGroupingKey.Ticket]: 'Ticket',
    [PermissionSetGroupingKey.Tip]: 'Tip Policies',
    [PermissionSetGroupingKey.UserBan]: 'User Ban / User Suspension',
    [PermissionSetGroupingKey.UserFleetAgreement]: 'Rider-Fleet Agreement',
    [PermissionSetGroupingKey.UserOwn]: 'User Own',
    [PermissionSetGroupingKey.Vehicle]: 'Vehicle',
    [PermissionSetGroupingKey.VehicleType]: 'Vehicle Type',
    [PermissionSetGroupingKey.Webhook]: 'Webhook',
    [PermissionSetGroupingKey.Workflow]: 'Workflow',
    [PermissionSetGroupingKey.NylasAdminGrant]: 'Calendar Connection',
    [PermissionSetGroupingKey.Fleet]: 'Fleet',
    [PermissionSetGroupingKey.TimeRule]: 'Time Rule',
    [PermissionSetGroupingKey.RiderRepresentative]: 'Rider Representative',
    [PermissionSetGroupingKey.EamAsset]: 'Asset',
    [PermissionSetGroupingKey.EamContact]: 'Contact',
    [PermissionSetGroupingKey.EamMeterEntry]: 'Meter Entries',
    [PermissionSetGroupingKey.Gtfs]: 'GTFS',
    [PermissionSetGroupingKey.GtfsRealtime]: 'GTFS Realtime',
    [PermissionSetGroupingKey.EamServiceTask]: 'Service Tasks',
    [PermissionSetGroupingKey.EamServiceProgram]: 'Service Programs',
    [PermissionSetGroupingKey.EamServiceSchedule]: 'Service Schedules',
    [PermissionSetGroupingKey.EamServiceScheduleTask]: 'Service Schedule Tasks',
    [PermissionSetGroupingKey.EamServiceReminder]: 'Service Reminders',
    [PermissionSetGroupingKey.EamWorkOrder]: 'EAM Work Orders',
    [PermissionSetGroupingKey.EamServiceEntry]: 'EAM Service Entries',
    [PermissionSetGroupingKey.EamPart]: 'EAM Parts',
    [PermissionSetGroupingKey.EamIssue]: 'EAM Issues',
    [PermissionSetGroupingKey.TripGroup]: 'Trip Groups',
    [PermissionSetGroupingKey.EdiEligibilityCheck]: 'EDI Eligibility Check Groups',
    [PermissionSetGroupingKey.EdiBrokerConfiguration]: 'EDI Broker Configuration Groups',
    [PermissionSetGroupingKey.EamInventory]: 'Inventory',
    [PermissionSetGroupingKey.EamLocation]: 'Locations',
    [PermissionSetGroupingKey.EamPurchaseOrder]: 'Purchase Orders',
    [PermissionSetGroupingKey.EamVendor]: 'Vendors',
    [PermissionSetGroupingKey.EamInspectionForm]: 'Inspection Forms',
    [PermissionSetGroupingKey.EamInspection]: 'Inspections',
    [PermissionSetGroupingKey.EamSetting]: 'Settings',
    [PermissionSetGroupingKey.EamEnergyEntry]: 'Energy Entries',
  } as const satisfies Record<PermissionSetGroupingKey, string>,
  description: {
    [PermissionSetGroupingKey.SuperAdminDefault]: '',
    [PermissionSetGroupingKey.SuperAdminEngineeringLead]: '',
    [PermissionSetGroupingKey.SuperAdminPartnerSuccess]: '',
    [PermissionSetGroupingKey.SuperAdminRoot]: '',
    [PermissionSetGroupingKey.SuperAdminSiteReliabilityEngineer]: '',
    [PermissionSetGroupingKey.SuperAdminTestRole]: '',
    [PermissionSetGroupingKey.AccessGrant]:
      'Access Grants are made up of a role and an object. When added to a user group, it provides that group a set of permissions (derived from the role) to the provided object (e.g. organization, or a specific object like a Case).',
    [PermissionSetGroupingKey.AdminUser]:
      'Platform Users are user accounts with access to the Spare Platform admin panel.',
    [PermissionSetGroupingKey.AiAgent]:
      'AI Voice takes phone calls and book requests in place of human booking agents.',
    [PermissionSetGroupingKey.Ai]: 'General-purpose AI within the Spare Platform admin panel.',
    [PermissionSetGroupingKey.Analytics]: "Spare's analytics and reporting product.",
    [PermissionSetGroupingKey.AnalyticsTemplateLibrary]: "Spare's Analytics Template Library",
    [PermissionSetGroupingKey.Announcement]:
      'App Announcements are shown to riders on the homescreen of the rider interface.',
    [PermissionSetGroupingKey.ApiKey]: 'API Keys allow 3rd party software to securely integrate with Spare Platform.',
    [PermissionSetGroupingKey.App]: '',
    [PermissionSetGroupingKey.AuditLog]: 'Audit Logs are records of actions taken within the Spare Platform.',
    [PermissionSetGroupingKey.AuthorizationGroup]:
      'User Groups are a collection of users that share common access grants and permissions across the organization and various objects',
    [PermissionSetGroupingKey.AuthorizationGroupMembership]:
      'User Group Memberships are the association between a user and a User Group.',
    [PermissionSetGroupingKey.AuthorizationRole]:
      'Roles are a set of permissions that define what actions a user can perform within the system. You are currently viewing the permissions of a role.',
    [PermissionSetGroupingKey.BulkMessage]:
      'Bulk Messages are one-time notifications that can be sent out to many riders at once.',
    [PermissionSetGroupingKey.CancellationReason]:
      'Cancellation reasons are options that platform users must select from when canceling a ride request.',
    [PermissionSetGroupingKey.DriverBreakReason]:
      'Driver Break Reasons are options that platform users must select from when recording a driver break.',
    [PermissionSetGroupingKey.QuickReply]:
      'Quick Replies are pre-defined message templates that can be quickly inserted during conversations.',
    [PermissionSetGroupingKey.Case]:
      "Cases track a specific rider's progress through a Case Type process in Eligibility. To use specific case features like forms, appointments, letters, and statuses, platform users need to have additional permissions.",
    [PermissionSetGroupingKey.CaseType]:
      "Case Types are standard processes that exist in Eligibility. Each Case tracks a specific rider's progress through the process of a Case Type.",
    [PermissionSetGroupingKey.Charge]:
      "Charges are records of riders' payment methods being charged money. They contain only limited information about the payment method to protect its security.",
    [PermissionSetGroupingKey.Comment]: 'Comments are notes that can be added to request and case in Spare Platform.',
    [PermissionSetGroupingKey.ConnectedAccount]: '',
    [PermissionSetGroupingKey.CustomLink]:
      'Custom links allow you to display links to your own external webpages, email addresses, or telephone numbers to the users.',
    [PermissionSetGroupingKey.DataRetentionSchedule]:
      'Data Retention Schedules configure how long data will be stored in Spare Platform before it is deleted.',
    [PermissionSetGroupingKey.Device]:
      'Devices are records of user devices that have Spare rider or driver apps installed.',
    [PermissionSetGroupingKey.DirectorySync]:
      "Directory Sync allows you to sync your organization's directory with Spare Platform.",
    [PermissionSetGroupingKey.Driver]: '',
    [PermissionSetGroupingKey.DriverUser]: 'Drivers are user accounts with access to the Spare Driver app.',
    [PermissionSetGroupingKey.DriverBreak]: 'Manage Driver Breaks and Break Reasons',
    [PermissionSetGroupingKey.Duty]: 'Duties are scheduled shifts that drivers are assigned to.',
    [PermissionSetGroupingKey.DutyDelay]:
      'Duty delays are events detected by Spare Engine which unexpectedly cause ETAs to become later.',
    [PermissionSetGroupingKey.DutyRequestOffer]:
      'Duty Request Offers give drivers the choice of accepting a request or rejecting it. These are only available on duties associated with accept/reject fleets.',
    [PermissionSetGroupingKey.EngageReporting]:
      'Eligibility Reporting allows creating and exporting custom reports about Eligibility activity.',
    [PermissionSetGroupingKey.Event]:
      "Events are records of actions being taken within Spare Platform. Events related to an object can usually be found in the object's Activity Log.",
    [PermissionSetGroupingKey.FarePass]:
      'Fare Passes are products which provide free or discounted rides to riders. Fare Pass Allocations are records of riders purchasing or being granted a Fare Pass.',
    [PermissionSetGroupingKey.FavoriteLocation]:
      "Favorite Locations allow storing addresses on a rider's profile for quick access when booking requests.",
    [PermissionSetGroupingKey.FixedRouteForDisplay]:
      'Fixed Route for Display allows you to control which GTFS fixed routes are displayed in the Spare app.',
    [PermissionSetGroupingKey.Form]:
      'Form Setup allows control over which fields must be filled out as part of a Case Template. For permissions affecting Case Forms themselves, see the Case category.',
    [PermissionSetGroupingKey.Group]:
      "Rider Groups are lists of riders. Groups can have Conditions, which affect the ride requests a rider is allowed to make. A Group Membership is a record of a rider's membership in a Rider Group and can include more details affecting the requests the rider can make. ",
    [PermissionSetGroupingKey.Ivr]: 'Interactive Voice Response',
    [PermissionSetGroupingKey.Journey]:
      'Journeys are multi-leg trips that can include both on-demand and fixed-route legs.',
    [PermissionSetGroupingKey.KnowledgeEntry]:
      'Knowledge Entries are information that Spare AI can use to answer questions from users.',
    [PermissionSetGroupingKey.LaunchReporting]:
      'Operations Reporting allows access to the Operations Reports area within Analytics.',
    [PermissionSetGroupingKey.Letter]: 'Letters are templated messages that belong to a specific Case.',
    [PermissionSetGroupingKey.NotificationDeliveryPolicy]: 'How phone notifications should be delivered to riders.',
    [PermissionSetGroupingKey.NotificationSetting]:
      "Notification Preferences are settings on a rider's profile that control the type of notifications they receive.",
    [PermissionSetGroupingKey.MatchingOutcome]:
      'Matching Outcomes record the result of Spare Engine trying to match a request to a duty.',
    [PermissionSetGroupingKey.OperationalAlerts]:
      'Operational Alerts are notifications for platform users about events occurring inside Spare.',
    [PermissionSetGroupingKey.Provider]: 'Providers are providers that share common permissions.',
    [PermissionSetGroupingKey.Organization]: 'An Organization is a transportation system running on Spare.',
    [PermissionSetGroupingKey.PaymentMethod]:
      'Payment Methods are records of personal payment methods riders have connected to their accounts, for example credit cards, debit cards, or Nimoca cards. They contain only limited information about the payment method to protect its security.',
    [PermissionSetGroupingKey.PaymentMethodType]:
      'Payment Method Types define the kinds of payment methods the organization is willing to accept.',
    [PermissionSetGroupingKey.PhoneNumber]: 'Phone Numbers are used to send and receive voice calls and SMS.',
    [PermissionSetGroupingKey.Platform]: '',
    [PermissionSetGroupingKey.Promo]: 'Promos are codes that provide discounted fares when applied to riders.',
    [PermissionSetGroupingKey.Realize]:
      "Realize is Spare's product for planning and simulating new and modified on-demand services.",
    [PermissionSetGroupingKey.ResolveReporting]:
      'Resolve Reporting allows creating and exporting custom reports about Resolve activity.',
    [PermissionSetGroupingKey.Request]:
      'Requests are ride bookings. Estimates are a preview of what rides are available, so that users can decide whether to proceed with booking a Request.',
    [PermissionSetGroupingKey.Review]: 'Riders can leave reviews after their trip is complete.',
    [PermissionSetGroupingKey.Rider]: '',
    [PermissionSetGroupingKey.RiderDriverRestriction]:
      'Rider-Driver Restrictions prevent a specific rider from being matched to a specific driver.',
    [PermissionSetGroupingKey.RiderRiderRestriction]: '',
    [PermissionSetGroupingKey.RiderOnboardingFlow]:
      'The Rider Guide is shown when riders first use the rider interface. Platform Users with permission can customize its content to suit your brand and service setup.',
    [PermissionSetGroupingKey.RiderVehicleTypeRestriction]:
      'Allowed Vehicle Types control which Vehicle Types a rider is allowed to ride with.',
    [PermissionSetGroupingKey.RiderUser]: 'Riders are user accounts that can take rides in the Spare system.',
    [PermissionSetGroupingKey.Service]: 'Services are the types of transit service your organization offers to riders.',
    [PermissionSetGroupingKey.Simulation]: '',
    [PermissionSetGroupingKey.Ticket]:
      'Tickets are payment methods riders can use for any transit service, whether powered by Spare or not.',
    [PermissionSetGroupingKey.Tip]:
      'Tip Policies define whether riders are prompted to tip their driver after their ride, and what tipping amounts are shown.',
    [PermissionSetGroupingKey.UserBan]: 'User Bans ban riders from taking rides for a specific period of time.',
    [PermissionSetGroupingKey.UserFleetAgreement]:
      'Rider-Fleet Agreements are records of a specific rider agreeing to ride with a specific 3rd-party fleet.',
    [PermissionSetGroupingKey.UserOwn]: '',
    [PermissionSetGroupingKey.Vehicle]:
      'Vehicles are specific buses, vans, or cars that provide transit service when assigned to a duty. Inspections are forms drivers can be asked to fill out before and after their duty.',
    [PermissionSetGroupingKey.VehicleType]:
      'Vehicle Types are groupings of vehicles that have the same capacity and interior layout.',
    [PermissionSetGroupingKey.Webhook]:
      'Webhooks automatically send real-time information from Spare to another system when a specific event occurs.',
    [PermissionSetGroupingKey.Workflow]:
      'Workflows are custom processes that perform specific actions in your organization when a triggering event occurs.',
    [PermissionSetGroupingKey.NylasAdminGrant]: '',
    [PermissionSetGroupingKey.Fleet]: '',
    [PermissionSetGroupingKey.TimeRule]: 'Time Rules help determine service availability',
    [PermissionSetGroupingKey.FareRule]: 'Fare Rules determine how much a rider pays to use a service',
    [PermissionSetGroupingKey.RiderRepresentative]:
      'The Rider Representative feature allows riders to designate other individuals as representatives, enabling them to book rides on their behalf',
    [PermissionSetGroupingKey.Gtfs]: 'Allows access to general GTFS operations, such as viewing stops from a dataset',
    [PermissionSetGroupingKey.GtfsRealtime]:
      'GTFS Realtime allows you to view vehicle positions and trip updates for your on-demand services (may require additional permissions)',
    [PermissionSetGroupingKey.SidebarProductVisibility]:
      'Controls which products appear in the sidebar (products may require additional permissions to show up)',
    [PermissionSetGroupingKey.EamAsset]: 'Manage assets',
    [PermissionSetGroupingKey.EamContact]: 'Manage contacts',
    [PermissionSetGroupingKey.EamMeterEntry]: 'Manage meter entries for assets',
    [PermissionSetGroupingKey.EamServiceTask]: 'Manage service tasks',
    [PermissionSetGroupingKey.EamServiceProgram]: 'Manage service programs',
    [PermissionSetGroupingKey.EamServiceSchedule]: 'Manage service schedules',
    [PermissionSetGroupingKey.EamServiceScheduleTask]: 'Manage service schedule task associations',
    [PermissionSetGroupingKey.EamServiceReminder]: 'Manage service reminders',
    [PermissionSetGroupingKey.EamWorkOrder]: 'Manage work orders in the EAM system',
    [PermissionSetGroupingKey.EamServiceEntry]: 'Manage service entries in the EAM system',
    [PermissionSetGroupingKey.EamPart]: 'EAM Parts',
    [PermissionSetGroupingKey.EamIssue]: 'EAM Issues',
    [PermissionSetGroupingKey.EamInventory]: 'Inventory',
    [PermissionSetGroupingKey.EamLocation]: 'Locations',
    [PermissionSetGroupingKey.EamPurchaseOrder]: 'Manage purchase orders for parts',
    [PermissionSetGroupingKey.TripGroup]: 'Manage trip groups',
    [PermissionSetGroupingKey.EdiEligibilityCheck]: 'Manage eligibility checks for EDI',
    [PermissionSetGroupingKey.EdiBrokerConfiguration]: 'Manage broker configurations for EDI',
    [PermissionSetGroupingKey.EamVendor]: 'Manage vendors for parts and services',
    [PermissionSetGroupingKey.EamInspectionForm]: 'Manage inspection forms',
    [PermissionSetGroupingKey.EamInspection]: 'Manage inspections',
    [PermissionSetGroupingKey.EamSetting]: 'Manage settings',
    [PermissionSetGroupingKey.EamEnergyEntry]: 'Manage energy entries for assets',
  } as const satisfies Record<PermissionSetGroupingKey, string>,
} as const satisfies ITranslationStringsBlueprint

export const permissionSetsEn = {
  name: {
    [DefaultSuperAdminPermissionSet.DefaultSuperAdmin]: 'Default Super Admin',
    [EngineeringLeadPermissionSet.EngineeringLead]: 'Engineering Lead',
    [PartnerSuccessPermissionSet.PartnerSuccess]: 'Partner Success Role',
    [RootSuperAdminPermissionSet.RootSuperAdmin]: 'Root Super Admin',
    [SiteReliabilityEngineerPermissionSet.SiteReliabilityEngineer]: 'Site Reliability Engineer',
    [SuperAdminTestRolePermissionSet.SuperAdminTestRole]: 'Super Admin Test Role',
    [AccessGrantPermissionSet.View]: 'View Access Grants',
    [AccessGrantPermissionSet.Write]: 'Create and Edit Access Grants',
    [AdminUserPermissionSet.View]: 'View Platform Users',
    [AdminUserPermissionSet.New]: 'Create Platform Users',
    [AdminUserPermissionSet.Edit]: 'Edit Platform Users',
    [AdminUserPermissionSet.Delete]: 'Delete Platform Users',
    [AdminUserPermissionSet.Import]: 'Import Platform Users',
    [AdminUserPermissionSet.EditOwn]: 'Edit Own Platform User',
    [AiAgentPermissionSet.View]: 'View AI Voice Agents',
    [AiAgentPermissionSet.Write]: 'Create and Edit AI Voice Agents',
    [AiPermissionSet.Chat]: 'Access to Spare AI Chat',
    [AnalyticsPermissionSet.Access]: 'Access Analytics',
    [AnalyticsTemplateLibraryPermissionSet.View]: 'View Analytics Templates',
    [AnalyticsTemplateLibraryPermissionSet.Write]: 'Create and Edit Analytics Templates',
    [AnalyticsTemplateLibraryPermissionSet.Archive]: 'Archive and Unarchive Analytics Templates',
    [AnalyticsTemplateLibraryPermissionSet.Delete]: 'Delete Analytics Templates',
    [AnnouncementPermissionSet.View]: 'View Rider App Announcements',
    [AnnouncementPermissionSet.Write]: 'Create and Edit Rider App Announcements',
    [ApiKeyPermissionSet.View]: 'View API Keys',
    [ApiKeyPermissionSet.Write]: 'Create and Edit API Keys',
    [ApiKeyPermissionSet.Delete]: 'Delete API Keys',
    [ApiKeyPermissionSet.KeyUser]: 'Manage API Key Users',
    [AppPermissionSet.View]: '',
    [AppPermissionSet.Manage]: '',
    [AppPermissionSet.AppInstallationView]: '',
    [AppPermissionSet.AppInstallationManage]: '',
    [AuditLogPermissionSet.View]: 'View Audit Logs',
    [AuditLogPermissionSet.ViewAlertRules]: 'View Audit Log Alert Rules',
    [AuditLogPermissionSet.WriteAlertRules]: 'Create and Edit Audit Log Alert Rules',
    [AuditLogPermissionSet.ViewAlerts]: 'View Audit Log Alerts',
    [AuthorizationGroupPermissionSet.View]: 'View User Groups',
    [AuthorizationGroupPermissionSet.Write]: 'Create and Edit User Groups',
    [AuthorizationGroupPermissionSet.Delete]: 'Delete User Groups',
    [AuthorizationRolePermissionSet.View]: 'View Roles',
    [AuthorizationRolePermissionSet.Write]: 'Create and Edit Roles',
    [AuthorizationRolePermissionSet.Delete]: 'Delete Roles',
    [AuthorizationGroupMembershipPermissionSet.View]: 'View User Group Memberships',
    [AuthorizationGroupMembershipPermissionSet.Write]: 'Create and Edit User Group Memberships',
    [BulkMessagePermissionSet.View]: 'View Bulk Messages',
    [BulkMessagePermissionSet.Write]: 'Create and Edit Bulk Messages',
    [CancellationReasonPermissionSet.View]: 'View Cancellation Reasons',
    [CancellationReasonPermissionSet.Write]: 'Create and Edit Cancellation Reasons',
    [CancellationReasonPermissionSet.Delete]: 'Delete Cancellation Reasons',
    [QuickReplyPermissionSet.View]: 'View Quick Replies',
    [QuickReplyPermissionSet.Write]: 'Create and Edit Quick Replies',
    [CasePermissionSet.View]: 'View Cases',
    [CasePermissionSet.ViewOwn]: '',
    [CasePermissionSet.SubmitOwn]: '',
    [CasePermissionSet.Write]: 'Create and Edit Cases',
    [CasePermissionSet.ViewForms]: 'View Case Forms',
    [CasePermissionSet.WriteForms]: 'Edit Case Forms',
    [CasePermissionSet.ViewLetters]: 'View Case Letters',
    [CasePermissionSet.WriteLetters]: 'Create and Edit Case Letters',
    [CasePermissionSet.WriteStatus]: 'Update Case Status',
    [CasePermissionSet.ViewAppointments]: 'View Case Appointments',
    [CasePermissionSet.WriteAppointments]: 'Create and Edit Case Appointments',
    [CasePermissionSet.ViewOwnAppointments]: '',
    [CasePermissionSet.WriteOwnAppointments]: 'Create and Edit Own Appointments',
    [CasePermissionSet.Delete]: 'Delete Cases',
    [CaseTypePermissionSet.View]: 'View Case Types',
    [CaseTypePermissionSet.Write]: 'Create and Edit Case Types',
    [ChargePermissionSet.View]: 'View Charges',
    [ChargePermissionSet.Refund]: 'Refund Charges',
    [CustomLinkPermissionSet.View]: 'View Custom Links',
    [CustomLinkPermissionSet.Write]: 'Create and Edit Custom Links',
    [DataRetentionSchedulePermissionSet.View]: 'View Data Retention Schedules',
    [DataRetentionSchedulePermissionSet.Write]: 'Create and Edit Data Retention Schedules',
    [DevicePermissionSet.View]: 'View Devices',
    [DirectorySyncPermissionSet.View]: 'View Directory Sync',
    [DirectorySyncPermissionSet.Sync]: 'Sync Directory',
    [DirectorySyncPermissionSet.Update]: 'Update Directory Sync',
    [DutyDelayPermissionSet.View]: 'View Duty Delays',
    [DriverPermissionSet.Driver]: '',
    [DriverUserPermissionSet.View]: 'View Drivers',
    [DriverUserPermissionSet.Edit]: 'Create and Edit Drivers',
    [DriverUserPermissionSet.Delete]: 'Delete Drivers',
    [DriverUserPermissionSet.Import]: 'Import Drivers',
    [DriverUserPermissionSet.Export]: 'Export Drivers',
    [DriverUserPermissionSet.WriteDriverBehaviour]: 'Update driver behaviour alerts',
    [DriverBreakPermissionSet.View]: 'View Driver Breaks',
    [DriverBreakPermissionSet.Write]: 'Create and Edit Driver Breaks',
    [DriverBreakPermissionSet.ViewReason]: 'View Driver Break Reasons',
    [DriverBreakPermissionSet.WriteReason]: 'Create and Edit Driver Break Reasons',
    [DriverBreakPermissionSet.DeleteReason]: 'Delete Driver Break Reasons',
    [DutyPermissionSet.View]: 'View Duties',
    [DutyPermissionSet.New]: 'Create Duties',
    [DutyPermissionSet.Edit]: 'Edit Duties',
    [DutyPermissionSet.Cancel]: 'Cancel Duties',
    [DutyPermissionSet.Delete]: 'Delete Duties',
    [DutyPermissionSet.Import]: 'Import Duties',
    [DutyPermissionSet.Export]: 'Export Duties',
    [DutyPermissionSet.InitiateTriggeredOptimization]: 'Manually Trigger Duty Optimization',
    [DutyPermissionSet.CompleteSlot]: 'Complete Pickup or Dropoff',
    [DutyPermissionSet.ViewVehicleLocation]: 'View Vehicle Location',
    [DutyPermissionSet.StartDriverConversation]: 'Send Driver Messages',
    [DutyPermissionSet.ViewDriverConversation]: 'View Driver Messages',
    [DutyRequestOfferPermissionSet.View]: 'View Duty Request Offers',
    [EngageReportingPermissionSet.View]: 'View Eligibility Reports',
    [EngageReportingPermissionSet.Write]: 'Create and Edit Eligibility Reports',
    [EngageReportingPermissionSet.Delete]: 'Delete Eligibility Reports',
    [EngageReportingPermissionSet.Export]: 'Export Eligibility Reports',
    [ResolveReportingPermissionSet.View]: 'View Resolve Reports',
    [ResolveReportingPermissionSet.Write]: 'Create and Edit Resolve Reports',
    [ResolveReportingPermissionSet.Delete]: 'Delete Resolve Reports',
    [ResolveReportingPermissionSet.Export]: 'Export Resolve Reports',
    [EventPermissionSet.View]: 'View Activity Log Events',
    [FarePassPermissionSet.View]: 'View Fare Passes',
    [FarePassPermissionSet.Write]: 'Create and Edit Fare Passes',
    [FarePassPermissionSet.ViewAllocation]: 'View Fare Pass Allocations',
    [FarePassPermissionSet.NewAllocation]: 'Create Fare Pass Allocations',
    [FarePassPermissionSet.EditAllocation]: 'Edit Fare Pass Allocations',
    [FarePassPermissionSet.ImportAllocations]: 'Import Fare Pass Allocations',
    [FarePassPermissionSet.ExportAllocations]: 'Export Fare Pass Allocations',
    [FavoriteLocationPermissionSet.View]: 'View Favorite Locations',
    [FavoriteLocationPermissionSet.Edit]: 'Edit Favorite Locations',
    [FavoriteLocationPermissionSet.Delete]: 'Delete Favorite Locations',
    [FavoriteLocationPermissionSet.Import]: 'Import Favorite Locations',
    [FixedRouteForDisplayPermissionSet.View]: 'View Fixed Route for Display',
    [FixedRouteForDisplayPermissionSet.Write]: 'Create and Edit Fixed Route for Display',
    [FormPermissionSet.View]: 'View Forms',
    [FormPermissionSet.Write]: 'Create and Edit Forms',
    [FormPermissionSet.ViewContents]: 'View Form Contents',
    [FormPermissionSet.WriteContents]: 'Edit Form Contents',
    [GtfsPermissionsSet.View]: 'View GTFS',
    [GtfsRealtimePermissionSet.ViewVehiclePositions]: 'View Vehicle Positions',
    [GroupPermissionSet.View]: 'View Groups',
    [GroupPermissionSet.Write]: 'Create and Edit Groups',
    [GroupPermissionSet.ViewMembership]: 'View Rider Group Memberships',
    [GroupPermissionSet.WriteMembership]: 'Manage Rider Group Memberships',
    [GroupPermissionSet.ViewOwnMembership]: 'View Own Rider Group Memberships',
    [GroupPermissionSet.WriteOwnMembership]: 'Manage Own Rider Group Memberships',
    [GroupPermissionSet.ViewCondition]: 'View Conditions',
    [GroupPermissionSet.WriteCondition]: 'Create and Edit Conditions',
    [GroupPermissionSet.ImportMembership]: 'Import Memberships',
    [GroupPermissionSet.ExportMembership]: 'Export Memberships',
    [IvrPermissionSet.ViewMetrics]: 'View Metrics',
    [JourneyPermissionSet.View]: 'View Journey',
    [JourneyPermissionSet.Write]: 'Create and Edit Journey',
    [KnowledgeEntryPermissionSet.View]: 'View Knowledge Entries',
    [KnowledgeEntryPermissionSet.Write]: 'Create and Edit Knowledge Entries',
    [PlatformPermissionSet.UsePortal]: 'Use Admin Portal',
    [PlatformPermissionSet.ViewSensitiveInformation]: 'View Sensitive Information',
    [SidebarProductVisibilityPermissionSet.ShowOperationsProduct]: 'Operations',
    [SidebarProductVisibilityPermissionSet.ShowEligibilityProduct]: 'Eligibility',
    [SidebarProductVisibilityPermissionSet.ShowResolveProduct]: 'Resolve',
    [SidebarProductVisibilityPermissionSet.ShowAnalyzeProduct]: 'Analytics',
    [SidebarProductVisibilityPermissionSet.ShowAnalyticsProduct]: 'Analytics (beta)',
    [SidebarProductVisibilityPermissionSet.ShowRealizeProduct]: 'Realize',
    [SidebarProductVisibilityPermissionSet.ShowEamProduct]: 'EAM',
    [SidebarProductVisibilityPermissionSet.ShowAiProduct]: 'AI',
    [SidebarProductVisibilityPermissionSet.ShowAdminProduct]: 'Admin',
    [LaunchReportingPermissionSet.View]: 'View Operations Reports',
    [LaunchReportingPermissionSet.Write]: 'Create and Edit Operations Reports',
    [LaunchReportingPermissionSet.Delete]: 'Delete Operations Reports',
    [LaunchReportingPermissionSet.Export]: 'Export Operations Reports',
    [LetterPermissionSet.View]: 'View Letters',
    [LetterPermissionSet.Write]: 'Create and Edit Letters',
    [NotificationSettingPermissionSet.View]: 'View Notification Settings',
    [NotificationSettingPermissionSet.Write]: 'Create and Edit Notification Settings',
    [NotificationDeliveryPolicyPermissionSet.View]: 'View Notification Delivery Policy',
    [NotificationDeliveryPolicyPermissionSet.Write]: 'Create and Edit Notification Delivery Policy',
    [MatchingOutcomePermissionSet.View]: 'View Matching Outcomes',
    [OperationalAlertsPermissionSet.Subscribe]: 'Subscribe',
    [OrganizationPermissionSet.ViewOwn]: 'View Organization',
    [OrganizationPermissionSet.EditOwn]: 'Configure Organization',
    [OrganizationPermissionSet.ViewConfiguration]: 'View Organization Configuration',
    [OrganizationPermissionSet.ViewBackupSettings]: 'View Organization Backup Settings',
    [OrganizationPermissionSet.ViewCustomSchemas]: 'View Custom Fields',
    [OrganizationPermissionSet.WriteCustomSchemas]: 'Create and Edit Custom Fields',
    [PaymentMethodPermissionSet.View]: 'View Payment Methods',
    [PaymentMethodPermissionSet.Delete]: 'Delete Payment Methods',
    [PaymentMethodPermissionSet.Export]: 'Export Payment Methods',
    [PaymentMethodPermissionSet.CollectDirectly]: 'Collect Directly',
    [PaymentMethodPermissionSet.InitiatePhoneCollection]: 'Initiate Phone Collection',
    [PaymentMethodTypePermissionSet.View]: 'View Payment Method Types',
    [PaymentMethodTypePermissionSet.Write]: 'Create and Edit Payment Method Types',
    [PaymentMethodTypePermissionSet.Export]: 'Export Payment Method Types',
    [PhoneNumberPermissionSet.View]: 'View Phone Numbers',
    [PhoneNumberPermissionSet.Configure]: 'Configure Existing Phone Numbers',
    [PhoneNumberPermissionSet.Purchase]: 'Purchase New Phone Numbers',
    [PhoneNumberPermissionSet.Delete]: 'Delete Existing Phone Numbers',
    [PromoPermissionSet.View]: 'View Promos',
    [PromoPermissionSet.Write]: 'Create and Edit Promos',
    [PromoPermissionSet.Export]: 'Export Promos',
    [PromoPermissionSet.ApplyToUser]: 'Apply Promo to Rider',
    [RealizePermissionSet.Access]: 'Access Realize',
    [RequestPermissionSet.Estimate]: 'Create Estimate',
    [RequestPermissionSet.EstimateWithOverrides]: 'Create Estimate with Flexibility Overrides',
    [RequestPermissionSet.CreateUnmatchedRequest]: 'Create Unmatched Request',
    [RequestPermissionSet.View]: 'View Request',
    [RequestPermissionSet.ViewDiscounts]: 'View Request Discounts',
    [RequestPermissionSet.ViewRequestPredictions]: 'View Request Predictions',
    [RequestPermissionSet.ViewConstraintOverrides]: 'View Flexibility Overrides',
    [RequestPermissionSet.ViewDailyCounts]: 'View Request Daily Counts',
    [RequestPermissionSet.Write]: 'Create and Edit Requests',
    [RequestPermissionSet.WriteRestricted]: 'Create and Edit Requests on Role-Restricted Services',
    [RequestPermissionSet.Rematch]: 'Rematch',
    [RequestPermissionSet.ManualIntervention]: 'Manual Intervention',
    [RequestPermissionSet.ManualInterventionSalesInfo]: 'Show PLEO',
    [RequestPermissionSet.ExportRequestRecurrences]: 'Export Request Recurrences',
    [RequestPermissionSet.LockToDuty]: 'Lock Request to Duty',
    [ReviewPermissionSet.View]: 'View Reviews',
    [ReviewPermissionSet.New]: 'Create Reviews',
    [RiderPermissionSet.Rider]: 'Manage Rider',
    [RiderDriverRestrictionPermissionSet.View]: 'View Rider-Driver Restrictions',
    [RiderDriverRestrictionPermissionSet.Create]: 'Create Rider-Driver Restriction',
    [RiderDriverRestrictionPermissionSet.Delete]: 'Delete Rider-Driver Restriction',
    [RiderRiderRestrictionPermissionSet.View]: 'View Rider Restrictions',
    [RiderRiderRestrictionPermissionSet.Create]: 'Create Rider Restrictions',
    [RiderRiderRestrictionPermissionSet.Delete]: 'Delete Rider Restrictions',
    [RiderOnboardingFlowPermissionSet.View]: 'View Rider Guide',
    [RiderOnboardingFlowPermissionSet.Write]: 'Edit Rider Guide',
    [RiderVehicleTypeRestrictionPermissionSet.View]: 'View Rider-Vehicle Type Restrictions',
    [RiderVehicleTypeRestrictionPermissionSet.Write]: 'Create and Edit Rider-Vehicle Type Restrictions',
    [RiderVehicleTypeRestrictionPermissionSet.Delete]: 'Delete Rider-Vehicle Type Restrictions',
    [RiderUserPermissionSet.View]: 'View Riders',
    [RiderUserPermissionSet.New]: 'Create Riders',
    [RiderUserPermissionSet.Edit]: 'Edit Riders',
    [RiderUserPermissionSet.Archive]: 'Archive Riders',
    [RiderUserPermissionSet.Delete]: 'Delete Riders',
    [RiderUserPermissionSet.Import]: 'Import Riders',
    [RiderUserPermissionSet.Export]: 'Export Riders',
    [RiderUserPermissionSet.SetPhonePin]: 'Set Phone PIN for Riders',
    [ServicePermissionSet.View]: 'View Services',
    [ServicePermissionSet.Share]: 'Share Services',
    [ServicePermissionSet.Write]: 'Create and Edit Services',
    [ServicePermissionSet.Delete]: 'Delete Services',
    [ServicePermissionSet.WriteRoute]: 'Create and Edit Route',
    [ServicePermissionSet.Import]: 'Import Service and Service Related Objects',
    [TicketPermissionSet.ViewInstance]: 'View Ticket Instances',
    [TicketPermissionSet.WriteInstance]: 'Edit Ticket Instances',
    [TicketPermissionSet.DeleteInstance]: 'Delete Ticket Instances',
    [TipPermissionSet.View]: 'View Tips',
    [TipPermissionSet.ViewPolicy]: 'View Tip Policies',
    [TipPermissionSet.WritePolicy]: 'Create and Edit Tip Policies',
    [TipPermissionSet.DeletePolicy]: 'Delete Tip Policies',
    [UserBanPermissionSet.View]: 'View User Bans',
    [UserBanPermissionSet.Write]: 'Create and Edit User Bans',
    [UserFleetAgreementPermissionSet.View]: 'View User Fleet Agreements',
    [UserFleetAgreementPermissionSet.New]: 'Create User Fleet Agreements',
    [UserFleetAgreementPermissionSet.Delete]: 'Delete User Fleet Agreements',
    [UserFleetAgreementPermissionSet.DeleteAll]: 'Delete All User Fleet Agreements',
    [UserOwnPermissionSet.User]: '',
    [UserOwnPermissionSet.Rider]: '',
    [UserOwnPermissionSet.Driver]: '',
    [UserOnlyTokenPermissionSet.User]: '',
    [VehiclePermissionSet.View]: 'View Vehicles',
    [VehiclePermissionSet.New]: 'Create Vehicles',
    [VehiclePermissionSet.Edit]: 'Edit Vehicles',
    [VehiclePermissionSet.Import]: 'Import Vehicles',
    [VehiclePermissionSet.Export]: 'Export Vehicles',
    [VehiclePermissionSet.ViewInspection]: 'View Vehicle Inspections',
    [VehiclePermissionSet.ManageInspection]: 'Create and Edit Vehicle Inspections',
    [VehicleTypePermissionSet.View]: 'View Vehicle Types',
    [VehicleTypePermissionSet.Write]: 'Create and Edit Vehicle Types',
    [VehicleTypePermissionSet.Delete]: 'Delete Vehicle Types',
    [WebhookPermissionSet.View]: 'View Webhooks',
    [WebhookPermissionSet.Write]: 'Create and Edit Webhooks',
    [WorkflowPermissionSet.View]: 'View Workflows',
    [WorkflowPermissionSet.Write]: 'Create and Edit Workflows',
    [WorkflowPermissionSet.Delete]: 'Delete Workflows',
    [EamAssetPermissionSet.View]: 'View Assets',
    [EamAssetPermissionSet.Write]: 'Create and Edit Assets',
    [EamAssetPermissionSet.ManageGroups]: 'Create and Edit Asset Groups',
    [EamContactPermissionSet.View]: 'View Contacts',
    [EamContactPermissionSet.Write]: 'Create and Edit Contacts',
    [NylasAdminGrantPermissionSet.Auth]: 'Connect Own Calendar',
    [NylasAdminGrantPermissionSet.View]: 'View Calendars',
    [NylasAdminGrantPermissionSet.Write]: 'Create and Edit Calendars',
    [NylasAdminGrantPermissionSet.ViewOwn]: 'View Own Calendar',
    [NylasAdminGrantPermissionSet.WriteOwn]: 'Create and Edit Calendars',
    [CommentPermissionSet.View]: 'View Comments',
    [CommentPermissionSet.Write]: 'Create Comments',
    [FleetPermissionSet.View]: 'View Fleets',
    [FleetPermissionSet.New]: 'Create New Fleets',
    [FleetPermissionSet.Edit]: 'Edit Fleets',
    [FleetPermissionSet.ForceEdit]: 'Force Edit Fleets',
    [TimeRulePermissionSet.View]: 'View Time Rules',
    [TimeRulePermissionSet.New]: 'Create Time Rules',
    [TimeRulePermissionSet.Edit]: 'Edit Time Rules',
    [TimeRulePermissionSet.Delete]: 'Delete Time Rules',
    [FareRulePermissionSet.View]: 'View Fare Rules',
    [FareRulePermissionSet.Write]: 'Create and Edit Fare Rules',
    [FareRulePermissionSet.Delete]: 'Delete Fare Rules',
    [RiderRepresentativePermissionSet.View]: 'View Rider Representatives',
    [RiderRepresentativePermissionSet.Write]: 'Create and Edit Rider Representatives',
    [LaunchReportingPermissionSet.CustomExport]: 'Export Custom Reports',
    [EamMeterEntryPermissionSet.View]: 'View Meter Entries',
    [EamMeterEntryPermissionSet.Write]: 'Create and Edit Meter Entries',
    [EamServiceTaskPermissionSet.View]: 'View Service Tasks',
    [EamServiceTaskPermissionSet.Write]: 'Create and Edit Service Tasks',
    [EamServiceProgramPermissionSet.View]: 'View Service Programs',
    [EamServiceProgramPermissionSet.Write]: 'Create and Edit Service Programs',
    [EamServiceSchedulePermissionSet.View]: 'View Service Schedules',
    [EamServiceSchedulePermissionSet.Write]: 'Create and Edit Service Schedules',
    [EamServiceScheduleTaskPermissionSet.View]: 'View Service Schedule Tasks',
    [EamServiceScheduleTaskPermissionSet.Write]: 'Create and Edit Service Schedule Tasks',
    [EamServiceReminderPermissionSet.View]: 'View Service Reminders',
    [EamServiceReminderPermissionSet.Write]: 'Create and Edit Service Reminders',
    [EamWorkOrderPermissionSet.View]: 'View Work Orders',
    [EamWorkOrderPermissionSet.Write]: 'Create and Edit Work Orders',
    [EamServiceEntryPermissionSet.View]: 'View Service Entries',
    [EamServiceEntryPermissionSet.Write]: 'Create and Edit Service Entries',
    [EamPartPermissionSet.View]: 'View Parts',
    [EamPartPermissionSet.Write]: 'Create and Edit Parts',
    [EamIssuePermissionSet.View]: 'View Issues',
    [EamIssuePermissionSet.Write]: 'Create and Edit Issues',
    [TripGroupPermissionSet.View]: 'View Trip Groups',
    [TripGroupPermissionSet.Write]: 'Create and Edit Trip Groups',
    [TripGroupPermissionSet.Delete]: 'Delete Trip Groups',
    [EdiBrokerConfigurationPermissionSet.View]: 'View EDI broker configurations',
    [EdiBrokerConfigurationPermissionSet.Write]: 'Manage EDI broker configurations',
    [EdiEligibilityCheckPermissionSet.View]: 'View EDI eligibility checks',
    [EdiEligibilityCheckPermissionSet.Write]: 'Manage EDI eligibility checks',
    [EamInventoryPermissionSet.View]: 'View Inventory & Transactions',
    [EamInventoryPermissionSet.Adjust]: 'Create Inventory Adjustments',
    [EamLocationPermissionSet.View]: 'View Locations',
    [EamLocationPermissionSet.Write]: 'Create and Edit Locations',
    [EamPurchaseOrderPermissionSet.View]: 'View Purchase Orders',
    [EamPurchaseOrderPermissionSet.Write]: 'Create and Edit Purchase Orders',
    [EamPurchaseOrderPermissionSet.Receive]: 'Receive Purchase Orders',
    [EamVendorPermissionSet.View]: 'View Vendors',
    [EamVendorPermissionSet.Write]: 'Create and Edit Vendors',
    [EamInspectionFormPermissionSet.View]: 'View inspection forms',
    [EamInspectionFormPermissionSet.Write]: 'Create and edit inspection forms',
    [EamInspectionPermissionSet.View]: 'View inspections',
    [EamInspectionPermissionSet.Write]: 'Create and edit inspections',
    [EamSettingPermissionSet.View]: 'View settings',
    [EamSettingPermissionSet.Write]: 'Edit settings',
    [EamEnergyEntryPermissionSet.View]: 'View energy entries for assets',
    [EamEnergyEntryPermissionSet.Write]: 'Create and edit energy entries for assets',
    [EamEnergyEntryPermissionSet.ManageTypes]: 'Create and edit energy types for assets',
    [ProviderPermissionSet.View]: 'View Providers',
    [ProviderPermissionSet.Write]: 'Create and Edit Providers',
  } as const satisfies Record<PermissionSetType, string>,
  description: {
    [DefaultSuperAdminPermissionSet.DefaultSuperAdmin]: '',
    [EngineeringLeadPermissionSet.EngineeringLead]: '',
    [PartnerSuccessPermissionSet.PartnerSuccess]: '',
    [RootSuperAdminPermissionSet.RootSuperAdmin]: '',
    [SiteReliabilityEngineerPermissionSet.SiteReliabilityEngineer]: '',
    [SuperAdminTestRolePermissionSet.SuperAdminTestRole]: '',
    [AccessGrantPermissionSet.View]: '',
    [AccessGrantPermissionSet.Write]: '',
    [AdminUserPermissionSet.View]: '',
    [AdminUserPermissionSet.New]: '',
    [AdminUserPermissionSet.Edit]: '',
    [AdminUserPermissionSet.Delete]: '',
    [AdminUserPermissionSet.Import]: '',
    [AdminUserPermissionSet.EditOwn]: 'Controls whether a platform user can edit their own admin user details.',
    [AiPermissionSet.Chat]: 'Allows users to use Spare AI Chat',
    [AiAgentPermissionSet.View]: '',
    [AiAgentPermissionSet.Write]: '',
    [AnalyticsPermissionSet.Access]: 'Access the Analytics product. This is required to use any Analytics features.',
    [AnalyticsTemplateLibraryPermissionSet.View]: 'View Analytics Templates',
    [AnalyticsTemplateLibraryPermissionSet.Write]: 'Create and Edit Analytics Templates',
    [AnalyticsTemplateLibraryPermissionSet.Archive]: 'Archive and Unarchive Analytics Templates',
    [AnalyticsTemplateLibraryPermissionSet.Delete]: 'Delete Analytics Templates',
    [AnnouncementPermissionSet.View]: '',
    [AnnouncementPermissionSet.Write]: '',
    [ApiKeyPermissionSet.View]: '',
    [ApiKeyPermissionSet.Write]: '',
    [ApiKeyPermissionSet.Delete]: '',
    [ApiKeyPermissionSet.KeyUser]: '',
    [AppPermissionSet.View]: '',
    [AppPermissionSet.Manage]: '',
    [AppPermissionSet.AppInstallationView]: '',
    [AppPermissionSet.AppInstallationManage]: '',
    [AuditLogPermissionSet.View]: 'Query audit logs',
    [AuditLogPermissionSet.ViewAlertRules]: 'View audit log alert rules',
    [AuditLogPermissionSet.WriteAlertRules]: 'Create and edit audit log alert rules',
    [AuditLogPermissionSet.ViewAlerts]: 'View audit log alerts',
    [AuthorizationGroupPermissionSet.View]: '',
    [AuthorizationGroupPermissionSet.Write]: '',
    [AuthorizationGroupPermissionSet.Delete]: '',
    [AuthorizationGroupMembershipPermissionSet.View]: '',
    [AuthorizationGroupMembershipPermissionSet.Write]: '',
    [AuthorizationRolePermissionSet.View]: '',
    [AuthorizationRolePermissionSet.Write]: '',
    [AuthorizationRolePermissionSet.Delete]: '',
    [BulkMessagePermissionSet.View]: '',
    [BulkMessagePermissionSet.Write]: 'Create, send, and edit bulk messages.',
    [CancellationReasonPermissionSet.View]: '',
    [CancellationReasonPermissionSet.Write]: '',
    [CancellationReasonPermissionSet.Delete]: '',
    [QuickReplyPermissionSet.View]: 'Allows viewing quick reply templates',
    [QuickReplyPermissionSet.Write]: 'Allows creating and modifying quick reply templates',
    [CasePermissionSet.View]:
      'View all cases. This is required to for permissions relating to case forms, case appointments, case letters, and case statuses to work.',
    [CasePermissionSet.ViewOwn]: 'View only cases created by this user and not cases created by any other user.',
    [CasePermissionSet.SubmitOwn]: '',
    [CasePermissionSet.Write]: '',
    [CasePermissionSet.ViewForms]: 'View forms belonging to any case.',
    [CasePermissionSet.WriteForms]: 'Create and edit forms belonging to any case.',
    [CasePermissionSet.ViewLetters]: 'View letters belonging to any case.',
    [CasePermissionSet.WriteLetters]: 'Create or edit letters belonging to any case.',
    [CasePermissionSet.WriteStatus]: 'Update the status of cases.',
    [CasePermissionSet.ViewAppointments]: '',
    [CasePermissionSet.WriteAppointments]: '',
    [CasePermissionSet.ViewOwnAppointments]: '',
    [CasePermissionSet.WriteOwnAppointments]: '',
    [CasePermissionSet.Delete]: 'Allows a user to permanently delete archived cases.',
    [CaseTypePermissionSet.View]: '',
    [CaseTypePermissionSet.Write]: '',
    [ChargePermissionSet.View]: '',
    [ChargePermissionSet.Refund]: 'Reverse existing charges. This returns money to riders that they have already paid.',
    [CustomLinkPermissionSet.View]: '',
    [CustomLinkPermissionSet.Write]: '',
    [DataRetentionSchedulePermissionSet.View]: '',
    [DataRetentionSchedulePermissionSet.Write]: '',
    [DevicePermissionSet.View]: '',
    [DirectorySyncPermissionSet.View]: '',
    [DirectorySyncPermissionSet.Sync]: '',
    [DirectorySyncPermissionSet.Update]: '',
    [DutyDelayPermissionSet.View]: '',
    [DriverPermissionSet.Driver]: '',
    [DriverUserPermissionSet.View]: '',
    [DriverUserPermissionSet.Edit]: '',
    [DriverUserPermissionSet.Delete]: '',
    [DriverUserPermissionSet.Import]: '',
    [DriverUserPermissionSet.Export]: '',
    [DriverUserPermissionSet.WriteDriverBehaviour]: 'Dismiss and add notes to driver behaviour alerts',
    [DriverBreakPermissionSet.View]: '',
    [DriverBreakPermissionSet.Write]: '',
    [DriverBreakPermissionSet.ViewReason]: '',
    [DriverBreakPermissionSet.WriteReason]: '',
    [DriverBreakPermissionSet.DeleteReason]: '',
    [DutyPermissionSet.View]: '',
    [DutyPermissionSet.New]: '',
    [DutyPermissionSet.Edit]: 'Edit duties, route assignments and driver breaks.',
    [DutyPermissionSet.Cancel]: '',
    [DutyPermissionSet.Delete]: '',
    [DutyPermissionSet.Import]: '',
    [DutyPermissionSet.Export]: '',
    [DutyPermissionSet.InitiateTriggeredOptimization]: 'Manually trigger optimization for a single duty.',
    [DutyPermissionSet.CompleteSlot]: 'Complete pickups or dropoffs on behalf of drivers.',
    [DutyPermissionSet.ViewVehicleLocation]: '',
    [DutyPermissionSet.StartDriverConversation]: '',
    [DutyPermissionSet.ViewDriverConversation]: '',
    [DutyRequestOfferPermissionSet.View]: '',
    [EngageReportingPermissionSet.View]: 'View Eligibility report templates and download reports.',
    [EngageReportingPermissionSet.Write]: 'Create and edit Eligibility report templates.',
    [EngageReportingPermissionSet.Delete]: '',
    [EngageReportingPermissionSet.Export]: '',
    [ResolveReportingPermissionSet.View]: 'View Resolve report templates and download reports.',
    [ResolveReportingPermissionSet.Write]: 'Create and edit Resolve report templates.',
    [ResolveReportingPermissionSet.Delete]: '',
    [ResolveReportingPermissionSet.Export]: '',
    [EventPermissionSet.View]: '',
    [FarePassPermissionSet.View]: '',
    [FarePassPermissionSet.Write]: '',
    [FarePassPermissionSet.ViewAllocation]: "View riders' fare passes",
    [FarePassPermissionSet.NewAllocation]: 'Allocate a fare pass to a rider.',
    [FarePassPermissionSet.EditAllocation]: 'Adjust rider fare passes',
    [FarePassPermissionSet.ImportAllocations]: '',
    [FarePassPermissionSet.ExportAllocations]: '',
    [FavoriteLocationPermissionSet.View]: '',
    [FavoriteLocationPermissionSet.Edit]: '',
    [FavoriteLocationPermissionSet.Delete]: '',
    [FavoriteLocationPermissionSet.Import]: '',
    [FixedRouteForDisplayPermissionSet.View]: '',
    [FixedRouteForDisplayPermissionSet.Write]: '',
    [FormPermissionSet.View]: 'View the fields belonging to each form inside a Case Template.',
    [FormPermissionSet.Write]: 'Create and edit forms belonging to a case.',
    [FormPermissionSet.ViewContents]: 'View the contents of forms belonging to a case.',
    [FormPermissionSet.WriteContents]: 'Create and edit the contents of forms belonging to a case.',
    [GtfsPermissionsSet.View]: 'View GTFS-related data, such as stops.',
    [GtfsRealtimePermissionSet.ViewVehiclePositions]: 'View vehicle positions from GTFS Realtime feeds.',
    [GroupPermissionSet.View]: '',
    [GroupPermissionSet.Write]: '',
    [GroupPermissionSet.ViewMembership]: '',
    [GroupPermissionSet.WriteMembership]: '',
    [GroupPermissionSet.ViewOwnMembership]: '',
    [GroupPermissionSet.WriteOwnMembership]: '',
    [GroupPermissionSet.ViewCondition]: 'View rider group conditions.',
    [GroupPermissionSet.WriteCondition]: 'Create and edit rider group conditions.',
    [GroupPermissionSet.ImportMembership]: '',
    [GroupPermissionSet.ExportMembership]: '',
    [IvrPermissionSet.ViewMetrics]: 'View IVR (Interactive Voice Response) metrics.',
    [JourneyPermissionSet.View]: '',
    [JourneyPermissionSet.Write]: '',
    [KnowledgeEntryPermissionSet.View]: '',
    [KnowledgeEntryPermissionSet.Write]: '',
    [PlatformPermissionSet.UsePortal]: 'Basic access to the Spare Platform.',
    [PlatformPermissionSet.ViewSensitiveInformation]: 'View Sensitive Information',
    [LaunchReportingPermissionSet.View]: 'View Operations report templates.',
    [LaunchReportingPermissionSet.Write]: 'Create and edit Operations report templates.',
    [LaunchReportingPermissionSet.Delete]: 'Delete Operations report templates.',
    [LaunchReportingPermissionSet.Export]: '',
    [LetterPermissionSet.View]: '',
    [LetterPermissionSet.Write]: '',
    [NotificationDeliveryPolicyPermissionSet.View]: 'View notification delivery policies and fallback phone numbers',
    [NotificationDeliveryPolicyPermissionSet.Write]:
      'Configure how notifications are sent to riders, including sender types and fallback numbers',
    [NotificationSettingPermissionSet.View]: '',
    [NotificationSettingPermissionSet.Write]: '',
    [MatchingOutcomePermissionSet.View]: '',
    [OperationalAlertsPermissionSet.Subscribe]:
      'Subscribe to operational alerts via email or in-product notifications.',
    [OrganizationPermissionSet.ViewOwn]: '',
    [OrganizationPermissionSet.EditOwn]: "Edit your organization's configuration.",
    [OrganizationPermissionSet.ViewConfiguration]: "View your organization's configuration.",
    [OrganizationPermissionSet.ViewBackupSettings]: "View your organization's backup settings.",
    [OrganizationPermissionSet.ViewCustomSchemas]: '',
    [OrganizationPermissionSet.WriteCustomSchemas]: '',
    [PaymentMethodPermissionSet.View]:
      'View payment methods. Users with this permission never have access to the full details of payment methods.',
    [PaymentMethodPermissionSet.Delete]: '',
    [PaymentMethodPermissionSet.Export]:
      'Export payment method data. Users with this permission never have access to the full details of payment methods.',
    [PaymentMethodPermissionSet.CollectDirectly]: 'Collect payments directly by charging a payment method.',
    [PaymentMethodPermissionSet.InitiatePhoneCollection]:
      "Initiate an automated phone call that securely collects payment method details and connects them to a rider's profile.",
    [PaymentMethodTypePermissionSet.View]: '',
    [PaymentMethodTypePermissionSet.Write]: '',
    [PaymentMethodTypePermissionSet.Export]: '',
    [PhoneNumberPermissionSet.View]: 'Read-only access to existing phone numbers',
    [PhoneNumberPermissionSet.Configure]: 'Update and import existing phone numbers',
    [PhoneNumberPermissionSet.Purchase]: 'Purchase new phone numbers',
    [PhoneNumberPermissionSet.Delete]: 'Delete existing phone numbers',
    [PromoPermissionSet.View]: '',
    [PromoPermissionSet.Write]: '',
    [PromoPermissionSet.Export]: '',
    [PromoPermissionSet.ApplyToUser]: 'Apply promos to riders.',
    [RealizePermissionSet.Access]: 'Access and use Spare Realize.',
    [RequestPermissionSet.Estimate]: 'Generate estimates that preview what rides are available.',
    [RequestPermissionSet.EstimateWithOverrides]:
      'Generate estimates that preview what rides are available, including options with pickup or dropoff times outside the normal limits.',
    [RequestPermissionSet.CreateUnmatchedRequest]:
      "Create requests even when Spare Engine can't find a vehicle to match them to.",
    [RequestPermissionSet.View]: '',
    [RequestPermissionSet.ViewDiscounts]: '',
    [RequestPermissionSet.ViewRequestPredictions]: '',
    [RequestPermissionSet.ViewConstraintOverrides]:
      'View instances of requests being booked or rescheduled with pickups or dropoffs outside the normal limits.',
    [RequestPermissionSet.ViewDailyCounts]: '',
    [RequestPermissionSet.Write]: '',
    [RequestPermissionSet.WriteRestricted]:
      'Choose role-restricted services when creating or editing requests. Users without this permission can still view role-restricted services and any associated requests. "Create and Edit Requests" permission is required for this to work.',
    [RequestPermissionSet.Rematch]:
      'Manually tell Spare to run the matching process again on an already-matched request.',
    [RequestPermissionSet.ManualIntervention]:
      'Perform manual interventions on requests, including: flexibility overrides, force match, complete pickup, complete dropoff, reverse pickup, reverse dropoff, reverse cancellation, and reverse no-show.',
    [RequestPermissionSet.ManualInterventionSalesInfo]: '',
    [RequestPermissionSet.ExportRequestRecurrences]: '',
    [RequestPermissionSet.LockToDuty]:
      'Lock requests to specific duties during request creation, bypassing normal matching logic.',
    [ReviewPermissionSet.View]: '',
    [ReviewPermissionSet.New]: '',
    [RiderPermissionSet.Rider]: '',
    [RiderDriverRestrictionPermissionSet.View]: 'View rider-driver restrictions.',
    [RiderDriverRestrictionPermissionSet.Create]: 'Create new rider-driver restrictions.',
    [RiderDriverRestrictionPermissionSet.Delete]: 'Delete rider-driver restrictions.',
    [RiderRiderRestrictionPermissionSet.View]: '',
    [RiderRiderRestrictionPermissionSet.Create]: '',
    [RiderRiderRestrictionPermissionSet.Delete]: '',
    [RiderOnboardingFlowPermissionSet.View]: 'View the rider guide.',
    [RiderOnboardingFlowPermissionSet.Write]: "Edit the rider guide's content.",
    [RiderVehicleTypeRestrictionPermissionSet.View]: 'View allowed vehicle types.',
    [RiderVehicleTypeRestrictionPermissionSet.Write]: 'Create and edit allowed vehicle types.',
    [RiderVehicleTypeRestrictionPermissionSet.Delete]: 'Delete allowed vehicle types.',
    [RiderUserPermissionSet.View]: '',
    [RiderUserPermissionSet.New]: '',
    [RiderUserPermissionSet.Edit]: '',
    [RiderUserPermissionSet.Archive]: '',
    [RiderUserPermissionSet.Delete]: '',
    [RiderUserPermissionSet.Import]: '',
    [RiderUserPermissionSet.Export]: '',
    [RiderUserPermissionSet.SetPhonePin]:
      'Set or reset rider phone PINs. PINs are used to securely identify riders who call in to book rides.',
    [ServicePermissionSet.View]: '',
    [ServicePermissionSet.Share]: '',
    [ServicePermissionSet.Write]: '',
    [ServicePermissionSet.Delete]: '',
    [ServicePermissionSet.WriteRoute]: '',
    [ServicePermissionSet.Import]: '',
    [TicketPermissionSet.ViewInstance]: '',
    [TicketPermissionSet.WriteInstance]: '',
    [TicketPermissionSet.DeleteInstance]: '',
    [TipPermissionSet.View]: 'View tip amounts.',
    [TipPermissionSet.ViewPolicy]: 'View tip policies.',
    [TipPermissionSet.WritePolicy]: 'Create and edit tip policies.',
    [TipPermissionSet.DeletePolicy]: 'Delete tip policies.',
    [UserBanPermissionSet.View]: '',
    [UserBanPermissionSet.Write]: '',
    [UserFleetAgreementPermissionSet.View]: 'View rider-fleet agreements.',
    [UserFleetAgreementPermissionSet.New]: 'Create rider-fleet agreements.',
    [UserFleetAgreementPermissionSet.Delete]: 'Delete rider-fleet agreements.',
    [UserFleetAgreementPermissionSet.DeleteAll]: 'Delete all rider-fleet agreements belonging to a specific fleet.',
    [UserOnlyTokenPermissionSet.User]: '',
    [UserOwnPermissionSet.User]: '',
    [UserOwnPermissionSet.Rider]: '',
    [UserOwnPermissionSet.Driver]: '',
    [VehiclePermissionSet.View]: '',
    [VehiclePermissionSet.New]: '',
    [VehiclePermissionSet.Edit]: '',
    [VehiclePermissionSet.Import]: '',
    [VehiclePermissionSet.Export]: '',
    [VehiclePermissionSet.ViewInspection]: '',
    [VehiclePermissionSet.ManageInspection]: '',
    [VehicleTypePermissionSet.View]: '',
    [VehicleTypePermissionSet.Write]: '',
    [VehicleTypePermissionSet.Delete]: '',
    [WebhookPermissionSet.View]: '',
    [WebhookPermissionSet.Write]: '',
    [WorkflowPermissionSet.View]: '',
    [WorkflowPermissionSet.Write]: '',
    [WorkflowPermissionSet.Delete]: '',
    [EamAssetPermissionSet.View]: '',
    [EamAssetPermissionSet.Write]: '',
    [EamAssetPermissionSet.ManageGroups]: '',
    [EamContactPermissionSet.View]: '',
    [EamContactPermissionSet.Write]: '',
    [NylasAdminGrantPermissionSet.Auth]: 'Securely connect your own calendar to Spare.',
    [NylasAdminGrantPermissionSet.View]: 'View any calendar.',
    [NylasAdminGrantPermissionSet.Write]: 'Create or edit calendars.',
    [NylasAdminGrantPermissionSet.ViewOwn]: 'View your calendar.',
    [NylasAdminGrantPermissionSet.WriteOwn]: 'Create or edit your own calendar.',
    [CommentPermissionSet.View]: 'View comments from yourself and others.',
    [CommentPermissionSet.Write]: 'Post comments',
    [FleetPermissionSet.View]: '',
    [FleetPermissionSet.New]: '',
    [FleetPermissionSet.Edit]: '',
    [FleetPermissionSet.ForceEdit]: 'Force dangerous edits to fleet configurations that may cause data loss.',
    [TimeRulePermissionSet.View]: '',
    [TimeRulePermissionSet.New]: '',
    [TimeRulePermissionSet.Edit]: '',
    [TimeRulePermissionSet.Delete]: '',
    [FareRulePermissionSet.View]: '',
    [FareRulePermissionSet.Write]: '',
    [FareRulePermissionSet.Delete]: '',
    [RiderRepresentativePermissionSet.View]: '',
    [RiderRepresentativePermissionSet.Write]: '',
    [LaunchReportingPermissionSet.CustomExport]: '',
    [EamMeterEntryPermissionSet.View]: 'View meter entries for assets',
    [EamMeterEntryPermissionSet.Write]: 'Create and modify meter entries for assets',
    [EamServiceTaskPermissionSet.View]: 'View service tasks',
    [EamServiceTaskPermissionSet.Write]: 'Create and modify service tasks',
    [EamServiceProgramPermissionSet.View]: 'View service programs',
    [EamServiceProgramPermissionSet.Write]: 'Create and modify service programs',
    [EamServiceSchedulePermissionSet.View]: 'View service schedules',
    [EamServiceSchedulePermissionSet.Write]: 'Create and modify service schedules',
    [EamServiceScheduleTaskPermissionSet.View]: 'View service schedule task associations',
    [EamServiceScheduleTaskPermissionSet.Write]: 'Create and modify service schedule task associations',
    [EamServiceReminderPermissionSet.View]: 'View service reminders',
    [EamServiceReminderPermissionSet.Write]: 'Create and edit service reminders',
    [EamWorkOrderPermissionSet.View]: 'View work orders',
    [EamWorkOrderPermissionSet.Write]: 'Manage work orders',
    [EamServiceEntryPermissionSet.View]: 'View service entries',
    [EamServiceEntryPermissionSet.Write]: 'Manage service entries',
    [EamPartPermissionSet.View]: 'View parts',
    [EamPartPermissionSet.Write]: 'Manage parts',
    [EamIssuePermissionSet.View]: 'View issues',
    [EamIssuePermissionSet.Write]: 'Manage issues',
    [EdiBrokerConfigurationPermissionSet.View]: '',
    [EdiBrokerConfigurationPermissionSet.Write]: '',
    [EdiEligibilityCheckPermissionSet.View]: '',
    [EdiEligibilityCheckPermissionSet.Write]: '',
    [TripGroupPermissionSet.View]: 'View Trip Groups',
    [TripGroupPermissionSet.Write]: 'Create and Edit Trip Groups',
    [TripGroupPermissionSet.Delete]: 'Delete Trip Groups',
    [EamInventoryPermissionSet.View]: 'View Inventory & Transactions',
    [EamInventoryPermissionSet.Adjust]: 'Create Inventory Adjustments',
    [EamLocationPermissionSet.View]: 'View Locations',
    [EamLocationPermissionSet.Write]: 'Create and Edit Locations',
    [EamPurchaseOrderPermissionSet.View]: 'Allows viewing purchase orders.',
    [EamPurchaseOrderPermissionSet.Write]: 'Allows creating and editing purchase orders.',
    [EamPurchaseOrderPermissionSet.Receive]: 'Allows marking purchase orders as received.',
    [EamVendorPermissionSet.View]: 'View Vendors',
    [EamVendorPermissionSet.Write]: 'Create and Edit Vendors',
    [EamInspectionFormPermissionSet.View]: 'View inspection forms',
    [EamInspectionFormPermissionSet.Write]: 'Create and edit inspection forms',
    [EamInspectionPermissionSet.View]: 'View inspections',
    [EamInspectionPermissionSet.Write]: 'Create and edit inspections',
    [EamSettingPermissionSet.View]: 'View settings',
    [EamSettingPermissionSet.Write]: 'Edit settings',
    [EamEnergyEntryPermissionSet.View]: 'View energy entries for assets',
    [EamEnergyEntryPermissionSet.Write]: 'Create and edit energy entries for assets',
    [EamEnergyEntryPermissionSet.ManageTypes]: 'Create and edit energy types for assets',
    [SidebarProductVisibilityPermissionSet.ShowAdminProduct]: '',
    [SidebarProductVisibilityPermissionSet.ShowOperationsProduct]: '',
    [SidebarProductVisibilityPermissionSet.ShowEligibilityProduct]: '',
    [SidebarProductVisibilityPermissionSet.ShowResolveProduct]: '',
    [SidebarProductVisibilityPermissionSet.ShowAnalyzeProduct]: '',
    [SidebarProductVisibilityPermissionSet.ShowAnalyticsProduct]: '',
    [SidebarProductVisibilityPermissionSet.ShowEamProduct]: '',
    [SidebarProductVisibilityPermissionSet.ShowAiProduct]: '',
    [SidebarProductVisibilityPermissionSet.ShowRealizeProduct]: '',
    [ProviderPermissionSet.View]: 'View Providers',
    [ProviderPermissionSet.Write]: 'Create, edit, and delete Providers',
  } as const satisfies Record<PermissionSetType, string>,
} as const satisfies ITranslationStringsBlueprint
